import { getConfig } from '../../../utils/getConfig.ts';

export const getRevisionRequestUrl = (inspectionId: string, revisionRequestId: string) => {
  const marketplaceBaseUrl = getConfig('INSPECTIFY_MARKETPLACE_BASE_URL');
  const url = `${marketplaceBaseUrl}/inspections/${inspectionId}/revision_requests/${revisionRequestId}`;
  return url;
}
